import React, { useEffect, useState } from 'react';
import { ReptoolModal } from '../../utilities/ReptoolModal.tsx';
import { ReptileTile } from '../../utilities/ReptileTile.tsx';
import { CollectionReptile } from '../../../types/CollectionReptile.ts';
import { Morph } from '../../../types/Morph.ts';
import { useRepToolContext } from '../../../RepToolContext.tsx';
export const ConfirmDeleteModal = ({
    confirmDeleteReptile,
    morphs,
    closeModal,
    deleteFunction
}: {
    confirmDeleteReptile: CollectionReptile,
    morphs: Morph[],
    closeModal: () => void,
    deleteFunction: () => void
}) => {
    const { appendControls } = useRepToolContext();
    const [understands, setUnderstands] = useState(false);
    const morph_name = confirmDeleteReptile.morph_name.split("het")[0];
    const beforeDelete = () => {
        if (understands) {
            localStorage.setItem("understands-delete", true);
        }
        deleteFunction();
        closeModal();
    }
    const addControls = () => {
        appendControls(
            <div className='btn btn-outline-light text-center w-100' onClick={beforeDelete}>
                Delete
            </div>, 'Confirm Delete Modal'
        )
    }
    useEffect(() => {
        appendControls(null, 'Confirm Delete Modal Use Effect');
        addControls();
        setTimeout(() => {
            appendControls(null, 'Confirm Delete Modal Timeout');
            addControls();
        }, 500)
    }, [])

    return (
        <ReptoolModal id="confirm-delete" title="Confirm Delete" closeModal={closeModal} body={(
            <React.Fragment>
                <h5>This will delete this reptile. Do you wish to continue?</h5>
                <div className='mt-5'>
                    <ReptileTile
                        reptile={confirmDeleteReptile}
                        morphInfo={morphs.find(morph => morph.name === morph_name) || morphs.find(morph => morph.name === "Wild Type") || null}
                        hideButton={true}
                    />
                </div>
                <div className="text-center mt-3 d-flex flex-row justify-content-center">
                    <input id="remember" type="checkbox" checked={understands} onClick={() => setUnderstands(!understands)} className="mr-2" />
                    <div className="text-light">Don't show this message again.</div>
                </div>

            </React.Fragment>
        )} />
    )
}